import * as React from "react"
import type { SVGProps } from "react"
const SvgVerticalAlignTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 5a1 1 0 0 1-.71-.29A1 1 0 0 1 4 4q0-.42.29-.71.29-.3.71-.29h14q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zm7 16a1 1 0 0 1-.71-.29A1 1 0 0 1 11 20v-9.2l-1.93 1.92a1 1 0 0 1-.67.28q-.4 0-.7-.3a1 1 0 0 1-.28-.7q0-.43.28-.7l3.6-3.6q.14-.15.32-.21t.38-.07.38.07q.17.06.32.21l3.63 3.62q.27.28.27.68t-.3.7a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28L13 10.8V20q0 .42-.29.71-.29.3-.71.29" />
  </svg>
)
export default SvgVerticalAlignTop
